import { SvgIconStyle } from '@onedesign/ui';
import { SxProps } from '@mui/material';
import Book from '/static/svg/ic_book.svg';
import BookOpen from '/static/svg/book_open_solid.svg';
import BookReader from '/static/svg/book_reader_solid.svg';
import Calendar from '/static/svg/calendar_alt_solid.svg';
import ChartPie from '/static/svg/chart_pie_solid.svg';
import CheckMark from '/static/svg/ic_checkmark.svg';
import ChevronDown from '/static/svg/ic_chevron_down.svg';
import ChevronLeft from '/static/svg/ic_chevron_left.svg';
import ChevronRight from '/static/svg/ic_chevron_right.svg';
import Close from '/static/svg/ic_close.svg';
import Copy from '/static/svg/copy_outline.svg';
import Download from '/static/svg/ic_download.svg';
import Edit from '/static/svg/ic_edit.svg';
import Error from '/static/svg/ic_error.svg';
import Expand from '/static/svg/expand_alt_solid.svg';
import EyeOff from '/static/svg/ic_eye_base_off.svg';
import EyeOn from '/static/svg/ic_eye_base_on.svg';
import Filter from '/static/svg/ic_filter.svg';
import IdCard from '/static/svg/id_card_solid.svg';
import Introduction from '/static/svg/ic_introduction.svg';
import Link from '/static/svg/ic_attach_file.svg';
import Minus from '/static/svg/ic_minus.svg';
import Person from '/static/svg/ic_person.svg';
import Plus from '/static/svg/plus_outline.svg';
import Point from '/static/svg/ic_point.svg';
import Search from '/static/svg/ic_search.svg';
import Send from '/static/svg/ic_send.svg';
import Settings from '/static/svg/ic_settings.svg';
import SignIn from '/static/svg/sign_in_alt_solid.svg';
import Trash from '/static/svg/trash_alt_solid.svg';
import UserClock from '/static/svg/user_clock_solid.svg';
import UserConfig from '/static/svg/ic_user_cog_solid.svg';
import UserGroup from '/static/svg/ic_user_group.svg';
import View from '/static/svg/ic_eye.svg';
import Language from '/static/svg/ic_language.svg';
import ExpandMore from '/static/svg/ic_expand_more.svg';
import Suitcase from '/static/svg/suitcase_solid.svg';
import Upload from '/static/svg/ic_upload.svg';
import File from '/static/svg/ic_file.svg';
import Youtube from '/static/svg/ic_youtube.svg';
import CheckedCircle from '/static/svg/ic_checked_circle_solid.svg';
import Plane from '/static/svg/telegram_plane.svg';
import BullHorn from '/static/svg/bullhorn_solid.svg';
import FileCheck from '/static/svg/file-circle-check_solid.svg';
import IcRefresh from '/static/svg/ic_refresh.svg';
import Alert from '/static/svg/ic_alert.svg';
import RedError from '/static/svg/ic_red_error.svg';
import MoreVertical from '/static/svg/more_vertical_solid.svg';
import Notification from '/static/svg/notification_on_solid.svg';
import Question from '/static/svg/ic_question.svg';
import Arrow from '/static/svg/ic_arrow.svg';
import PersonTie from '/static/svg/user_tie_solid.svg';
import SeriesLesson from '/static/svg/ic_series_lesson.svg';
import WhiteTrash from '/static/svg/ic_white_trash.svg';
import Divider from '/static/svg/divider.svg';
import Line from '/static/svg/ic_line.svg';
import LineBackground from '/static/svg/ic_line_background.svg';
import OneAnswer from '/static/svg/one_answer.svg';
import PaperClip from '/static/svg/ic_paper_clip.svg';
import PlayVideo from '/static/svg/play_video.svg';
import RemovingAccountSetting from '/static/svg/ic_removing_account_setting.svg';
import TrashThin from '/static/svg/ic_trash_thin.svg';
import OneAnswerAi from '/static/svg/icon_ai.svg';
import ContainedCopy from '/static/svg/ic_copy.svg';
import Prev from '/static/svg/ic_prev.svg';
import Next from '/static/svg/ic_next.svg';
import Receipt from '/static/svg/ic_receipt.svg';
import Child from '/static/svg/child_solid.svg';
import Compensation from '/static/svg/ic_compensation.svg';

const SVG = {
  Book,
  BookOpen,
  BookReader,
  Calendar,
  ChartPie,
  CheckMark,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Close,
  Copy,
  Download,
  Edit,
  Error,
  Expand,
  EyeOff,
  EyeOn,
  Filter,
  IdCard,
  Introduction,
  Link,
  Minus,
  Person,
  Plus,
  Point,
  Search,
  Send,
  Settings,
  SignIn,
  Trash,
  UserClock,
  UserConfig,
  UserGroup,
  View,
  Language,
  ExpandMore,
  Suitcase,
  Upload,
  File,
  Youtube,
  CheckedCircle,
  Plane,
  BullHorn,
  FileCheck,
  IcRefresh,
  Alert,
  RedError,
  MoreVertical,
  Notification,
  Question,
  Arrow,
  PersonTie,
  SeriesLesson,
  WhiteTrash,
  Divider,
  Line,
  LineBackground,
  OneAnswer,
  PaperClip,
  PlayVideo,
  RemovingAccountSetting,
  TrashThin,
  OneAnswerAi,
  ContainedCopy,
  Prev,
  Next,
  Receipt,
  Child,
  Compensation,
};

export enum SvgName {
  Book = 'Book',
  BookOpen = 'BookOpen',
  BookReader = 'BookReader',
  Calendar = 'Calendar',
  ChartPie = 'ChartPie',
  CheckMark = 'CheckMark',
  ChevronDown = 'ChevronDown',
  ChevronLeft = 'ChevronLeft',
  ChevronRight = 'ChevronRight',
  Close = 'Close',
  Copy = 'Copy',
  Download = 'Download',
  Edit = 'Edit',
  Error = 'Error',
  Expand = 'Expand',
  EyeOff = 'EyeOff',
  EyeOn = 'EyeOn',
  Filter = 'Filter',
  IdCard = 'IdCard',
  Introduction = 'Introduction',
  Link = 'Link',
  Minus = 'Minus',
  Person = 'Person',
  Plus = 'Plus',
  Point = 'Point',
  Search = 'Search',
  Send = 'Send',
  Settings = 'Settings',
  RemovingAccountSetting = 'RemovingAccountSetting',
  SignIn = 'SignIn',
  Trash = 'Trash',
  UserClock = 'UserClock',
  UserConfig = 'UserConfig',
  UserGroup = 'UserGroup',
  View = 'View',
  Language = 'Language',
  ExpandMore = 'ExpandMore',
  Suitcase = 'Suitcase',
  Upload = 'Upload',
  File = 'File',
  Youtube = 'Youtube',
  CheckedCircle = 'CheckedCircle',
  Plane = 'Plane',
  BullHorn = 'BullHorn',
  FileCheck = 'FileCheck',
  IcRefresh = 'IcRefresh',
  Alert = 'Alert',
  RedError = 'RedError',
  MoreVertical = 'MoreVertical',
  Notification = 'Notification',
  Question = 'Question',
  Arrow = 'Arrow',
  PersonTie = 'PersonTie',
  SeriesLesson = 'SeriesLesson',
  WhiteTrash = 'WhiteTrash',
  Divider = 'Divider',
  Line = 'Line',
  LineBackground = 'LineBackground',
  OneAnswer = 'OneAnswer',
  PaperClip = 'PaperClip',
  PlayVideo = 'PlayVideo',
  TrashThin = 'TrashThin',
  OneAnswerAi = 'OneAnswerAi',
  ContainedCopy = 'ContainedCopy',
  Prev = 'Prev',
  Next = 'Next',
  Receipt = 'Receipt',
  Child = 'Child',
  Compensation = 'Compensation',
}

type Props = {
  name: SvgName;
  sx?: SxProps;
};

export const Icon = ({
  name,
  sx = { width: '24px', height: '24px' },
}: Props) => {
  return <SvgIconStyle src={SVG[name]} sx={sx} />;
};
